// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetCriteria = dealers => ({
    dealers,
    type: actions.RESET_REGISTRATIONS_REVIEW_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/criteria.js